/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Condition,
  Condition$inboundSchema,
  Condition$Outbound,
  Condition$outboundSchema,
} from "./condition.js";

/**
 * The logical operator used to combine the conditions.
 */
export const ConditionGroupOperator = {
  LogicalAnd: "logical_and",
  LogicalOr: "logical_or",
} as const;
/**
 * The logical operator used to combine the conditions.
 */
export type ConditionGroupOperator = OpenEnum<typeof ConditionGroupOperator>;

/**
 * Defines a group of conditions combined with a logical operator (AND/OR).
 */
export type ConditionGroup = {
  /**
   * An array of conditions to be combined with the logical operator.
   */
  conditions: Array<Condition>;
  /**
   * Optional name for the condition, useful for debugging and documentation.
   */
  name?: string | undefined;
  /**
   * Whether to negate the entire group result.
   */
  negate?: boolean | undefined;
  /**
   * The logical operator used to combine the conditions.
   */
  operator?: ConditionGroupOperator | undefined;
};

/** @internal */
export const ConditionGroupOperator$inboundSchema: z.ZodType<
  ConditionGroupOperator,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(ConditionGroupOperator);
/** @internal */
export const ConditionGroupOperator$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  ConditionGroupOperator
> = openEnums.outboundSchema(ConditionGroupOperator);

/** @internal */
export const ConditionGroup$inboundSchema: z.ZodType<
  ConditionGroup,
  z.ZodTypeDef,
  unknown
> = z.object({
  conditions: z.array(Condition$inboundSchema),
  name: types.optional(types.string()),
  negate: types.boolean().default(false),
  operator: ConditionGroupOperator$inboundSchema.default("logical_and"),
});
/** @internal */
export type ConditionGroup$Outbound = {
  conditions: Array<Condition$Outbound>;
  name?: string | undefined;
  negate: boolean;
  operator: string;
};

/** @internal */
export const ConditionGroup$outboundSchema: z.ZodType<
  ConditionGroup$Outbound,
  z.ZodTypeDef,
  ConditionGroup
> = z.object({
  conditions: z.array(Condition$outboundSchema),
  name: z.string().optional(),
  negate: z.boolean().default(false),
  operator: ConditionGroupOperator$outboundSchema.default("logical_and"),
});

export function conditionGroupToJSON(conditionGroup: ConditionGroup): string {
  return JSON.stringify(ConditionGroup$outboundSchema.parse(conditionGroup));
}
export function conditionGroupFromJSON(
  jsonString: string,
): SafeParseResult<ConditionGroup, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConditionGroup$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConditionGroup' from JSON`,
  );
}
